import { create } from "zustand";

export interface FlowAction {
	id: string;
	name: string;
	steps: string[];
	flowTypeId: string;
	inputSchema: Record<string, unknown>;
	outputSchema: Record<string, unknown>;
	createdAt: string;
	updatedAt: string;
	createdBy: string;
	updatedBy: string;
}

interface FlowActionsState {
	flowActions: FlowAction[];
	selectedFlowAction: FlowAction | null;
	isDeleting: boolean;
	setFlowActions: (flowActions: FlowAction[]) => void;
	setSelectedFlowAction: (flowAction: FlowAction | null) => void;
	setIsDeleting: (isDeleting: boolean) => void;
	addFlowAction: (flowAction: FlowAction) => void;
	updateFlowAction: (id: string, flowAction: Partial<FlowAction>) => void;
	deleteFlowAction: (id: string) => void;
	clearFlowActions: () => void;
}

export const useFlowActionsStore = create<FlowActionsState>((set) => ({
	flowActions: [],
	selectedFlowAction: null,
	isDeleting: false,
	setFlowActions: (flowActions) => set({ flowActions }),
	setSelectedFlowAction: (flowAction) =>
		set({ selectedFlowAction: flowAction }),
	setIsDeleting: (isDeleting) => set({ isDeleting }),
	addFlowAction: (flowAction) =>
		set((state) => ({
			flowActions: [...state.flowActions, flowAction]
		})),
	updateFlowAction: (id, flowAction) =>
		set((state) => ({
			flowActions: state.flowActions.map((fa) =>
				fa.id === id ? { ...fa, ...flowAction } : fa
			)
		})),
	deleteFlowAction: (id) =>
		set((state) => ({
			flowActions: state.flowActions.filter((fa) => fa.id !== id)
		})),
	clearFlowActions: () => set({ flowActions: [], selectedFlowAction: null })
}));
